export default __webpack_public_path__ + "static/media/Welcome-gif-M-1B.e1ec3c53.png";